import { render } from "./PackageForYou.vue?vue&type=template&id=3a601cc8&scoped=true"
import script from "./PackageForYou.vue?vue&type=script&lang=js"
export * from "./PackageForYou.vue?vue&type=script&lang=js"

import "./PackageForYou.vue?vue&type=style&index=0&id=3a601cc8&lang=scss&scoped=true"
import "./PackageForYou.vue?vue&type=style&index=1&id=3a601cc8&lang=scss"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a601cc8"]])

export default __exports__